const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const AZURE_TOKEN_URL = process.env.REACT_APP_AZURE_BLOB_STORAGE_TOKEN;
const AZURE_ACCOUNT_NAME =
  process.env.REACT_APP_AZURE_BLOB_SERVICE_ACCOUNT_NAME;

// eslint-disable-next-line import/prefer-default-export
export { BASE_URL, AZURE_ACCOUNT_NAME, AZURE_TOKEN_URL };
